import { render } from "./SaihList.component.vue?vue&type=template&id=44c7a40a&scoped=true&ts=true"
import script from "./SaihList.component.vue?vue&type=script&lang=ts"
export * from "./SaihList.component.vue?vue&type=script&lang=ts"

import "./SaihList.component.vue?vue&type=style&index=0&id=44c7a40a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c7a40a"]])

export default __exports__